import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class SolicitudesOrdenesFisicasService {

  private readonly base = '/company/physical-order-requests';
  private readonly ordersBase = '/transactions/orders/sequence';

  constructor(private api: ApiService) {}

  // `token` es legacy y se ignora (el token va en el header Bearer).

  listarSolicitudes(_token?: string): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/list`, {});
  }

  buscarSolicitudesPorSecuencia(_token: string, secuencia: string): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/list`, { secuencia: String(secuencia || '').trim() });
  }

  totalBlocksDisponibles(_token: string, solicitud: string, desde: string, hasta: string): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/available`, { solicitud, desde, hasta });
  }

  listarBlocksSeguimiento(_token: string, solicitud: string, desde: string, hasta: string): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/blocks/list`, { solicitud, desde, hasta });
  }

  listarSecuenciasPorBlock(_token: string, block: string): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/sequences/list`, { block });
  }

  listarAsesores(_token?: string): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/advisors/list`, {});
  }

  buscarBlocksGlobal(_token: string, termino: string): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/blocks/search`, { termino });
  }

  buscarDoctores(_token: string, busqueda: string): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/doctors/search`, { busqueda: String(busqueda || '').trim() });
  }

  asignarAsesor(_token: string, idBlock: string, idAsesor: string, nombreAsesor: string, precio: string): Observable<{ idBlock: any }> {
    return this.api.post(`${this.base}/advisors/assign`, { idBlock, idAsesor, nombreAsesor, precio });
  }

  asignarDoctor(_token: string, idBlock: string, codigoDoctor: string, nombreDoctor: string): Observable<{ idBlock: any }> {
    return this.api.post(`${this.base}/doctors/assign`, { idBlock, codigoDoctor, nombreDoctor });
  }

  asignarDoctorSecuencia(_token: string, idSecuencia: string, codigoDoctor: string, nombreDoctor: string): Observable<any> {
    return this.api.post(`${this.base}/doctors/assign-sequence`, { idSecuencia, codigoDoctor, nombreDoctor });
  }

  // Estos dos viven en el dominio de órdenes (transactions/orders/sequence).
  buscarOrdenesParaSecuencia(_token: string, tipoBusqueda: string, busqueda: string): Observable<{ rows: any[] }> {
    return this.api.post(`${this.ordersBase}/search`, { search: busqueda, searchType: tipoBusqueda });
  }

  asignarOrdenSecuencia(_token: string, secuencial: string, codOrden: string): Observable<any> {
    return this.api.post(`${this.ordersBase}/assign`, { orderId: codOrden, sequence: secuencial });
  }

  obtenerInicializacion(_token?: string): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/initialize`, {});
  }

  generarBlocks(_token: string, totalTalonario: number, secuencialTalonario: number, secuencialBlock: number): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/blocks/generate`, {
      totalTalonario,
      prefijoSecuencia: '',
      secuencialTalonario,
      secuencialBlock
    });
  }

  generarBlocksConPrefijo(_token: string, totalTalonario: number, prefijoSecuencia: string, secuencialTalonario: number, secuencialBlock: number): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/blocks/generate`, {
      totalTalonario,
      prefijoSecuencia,
      secuencialTalonario,
      secuencialBlock
    });
  }

  obtenerSiguienteSecuencia(_token: string, prefijo: string): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/next-sequence`, { prefijo });
  }

  crearPrefijoSecuencial(_token: string, prefijo: string): Observable<any> {
    return this.api.post(`${this.base}/prefixes/create`, { prefijo });
  }

  crearSolicitud(payload: {
    token?: string;
    totalTalonarios: number;
    secuencia: number;
    prefijoSecuencia: string;
    tablaAsignacionBlocks: any[];
    responsable: string;
    proveedores: any[];
    tipoPrecio: string;
    detallePrecios2D: any[];
  }): Observable<any> {
    const { token, ...data } = payload;
    return this.api.post(`${this.base}/create`, data);
  }
}
